import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(theme => ({
  itemContainer: {
    flexGrow: 0,
    flexShrink: 0,
    backgroundColor: theme.palette.background.paper,
    borderRight: `1px solid ${theme.palette.divider}`,
    lineHeight: `${theme.spacing(3)}px`,
    position: 'sticky',
    left: 0,
    zIndex: 4,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  totalContainer: {
    zIndex: 3
  }
}));
